import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Modal } from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDashboard,
  faClockRotateLeft,
  faUsers,
  faProjectDiagram,
  faKey,
  faBriefcase,
  faPaperPlane,
  faQuestion,
  faImage,
  faCopy,
  faTimes,
  faPlugCirclePlus,
  faWarning,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Button, Row, Col } from "react-bootstrap";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { useAuthDispatch, logout, useAuthState } from "../../Context";
import { authRoutes } from "../../Routes";
import CashBar from "./CashBar";

let timerStack = [];

function SideBar(props) {
  const [logoutModal, setShowLogoutModal] = useState(false);
  const [currentTime, setCurrentTime] = useState(props.movement);
  const [timeOutCounter, setTimeOutCounter] = useState(30);
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const clearTimers = () => {
    for (let iTimer = 0; iTimer < timerStack.length; iTimer += 1) {
      const timer = timerStack[iTimer];
      clearTimeout(timer);
    }
    setTimeOutCounter(30);
  };

  const decreaseTimeout = timeCount => {
    timerStack.push(
      setTimeout(() => {
        const newTimeout = timeCount - 1;

        setTimeOutCounter(newTimeout);

        if (newTimeout <= 0) {
          setShowLogoutModal(false);
          handleLogout();
        } else {
          decreaseTimeout(newTimeout);
        }
      }, 1000)
    );
  };

  const timeoutTimer = () => {
    timerStack = [];

    setTimeout(() => {
      setCurrentTime(new Date());
      setShowLogoutModal(true);
      decreaseTimeout(30);
    }, 10 * 60 * 1000);
  };

  useEffect(() => {
    timeoutTimer();
  }, []);

  const userDetails = useAuthState(); //read user details from context

  const handleLogout = () => {
    logout(dispatch); //call the logout action

    navigate(0); //navigate to dashboard on success
  };

  const location = useLocation();

  return (
    <>
      <Modal
        open={logoutModal}
        onClose={() => {
          setShowLogoutModal(false);
          clearTimers();
          timeoutTimer();
        }}
      >
        <h2>Déconnexion automatique</h2>
        <p className="counter">
          <p className="counterValue">{timeOutCounter}</p>
        </p>
        <p>
          Vous êtes inactif depuis plus de 10 minutes. <br />
          <br /> Pour des raisons de sécurité, vous allez être déconnecté dans
          les 30 secondes. <br /> Veuillez presser le bouton pour annuler.
        </p>
        <Row>
          <Col xs={12}>
            <a
              className={`btn btn-cta right`}
              onClick={() => {
                setShowLogoutModal(false);
                clearTimers();
                timeoutTimer();
              }}
            >
              <FontAwesomeIcon size="lg" icon={faCheckCircle} />
              &nbsp; Annuler
              <div className="btn-cta-overlay"></div>
            </a>
          </Col>
        </Row>
      </Modal>
      <div className={classNames("sidebar", { "is-open": props.isOpen })}>
        <div className="sidebar-header">
          <Button
            variant="link"
            onClick={props.toggle}
            style={{ color: "#fff" }}
            className="mt-4"
          >
            <FontAwesomeIcon icon={faTimes} pull="right" size="xs" />
          </Button>
          <h3>
            <a href="/dashboard">
              <img id="logo" src="/img/penge_logo_white.png" width="177" />
              <img id="logoMobile" src="/img/logo_mobile.png" />
            </a>
          </h3>
        </div>
        <CashBar />
        <Nav className="menuLeft flex-column pt-2">
          {authRoutes
            .filter(route => route.isMenu)
            .map(route => {
              return (
                <Nav.Item
                  style={{ color: "#fff" }}
                  className={route.path === location.pathname ? "active" : ""}
                >
                  <Nav.Link href={route.path} style={{ color: "#fff" }}>
                    <FontAwesomeIcon icon={route.icon} className="mr-2" />
                    &nbsp;{route.title}
                  </Nav.Link>
                </Nav.Item>
              );
            })}
        </Nav>
      </div>
    </>
  );
}

export default SideBar;
